import { captureException } from '@sentry/react';
import { httpClient } from './http-client';

type Data =
  | {
      instance: string;
      error: undefined;
    }
  | {
      instance: undefined;
      error: string;
    };

export const getInstance = async (metaSiteId: string): Promise<string | null> => {
  try {
    const { data } = await httpClient.get<Data>(`/media-manager/getInstance?msid=${metaSiteId}`);

    if (data.error) {
      throw new Error(`[getInstance]: ${data.error}`);
    }

    return data.instance;
  } catch (e) {
    captureException(e);
    return null;
  }
};
